import {HttpErrorResponse,HttpEvent,HttpHandler,HttpInterceptor,HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {Observable,throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

/**
 * Intercepteur HTTP chargé de notifier un blocage
 */
@Injectable()
export class CsrfInterceptor implements HttpInterceptor {
	constructor(private toastrService: ToastrService,private translateService: TranslateService) {}

	/**
	 * Affiche un toast en cas de 403 - Blocage CSRF
	 */
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				//Si le blocage CSRF est détecté
				if (error?.status === 403 && error?.headers?.get('X-CSRF-ERROR') === 'true') {
					//Affichage d'un message utilisateur
					this.toastrService.error(this.translateService.instant('global.errors.csrf'));
				}
				return throwError(() => error);
			})
		);
	}
}
